import { render, staticRenderFns } from "./PostMore.vue?vue&type=template&id=52bf1b06"
import script from "./PostMore.vue?vue&type=script&lang=js"
export * from "./PostMore.vue?vue&type=script&lang=js"
import style0 from "./PostMore.vue?vue&type=style&index=0&id=52bf1b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports